package io.horion.auth.presentation.ui.components.profile

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.auth.domain.models.AppLanguage
import io.horion.auth.domain.models.ProfileSection
import io.horion.auth.presentation.ui.styles.LogoStyle
import io.horion.auth.presentation.ui.theme.AuthTheme
import io.horion.auth.presentation.ui.theme.AuthTypography
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*

@Composable
fun ProfileSidebar(
    currentSection: ProfileSection,
    onSectionChange: (ProfileSection) -> Unit,
    onLogout: () -> Unit,
) {
    val ctx = rememberPageContext()
    val colorMode = ColorMode.current
    val colors = AuthTheme.colors(colorMode)
    val strings = AppLanguage.strings

    var isHelpOpen by remember { mutableStateOf(false) }
    val logoPath = if (colorMode.isLight) "/Logo_orion.png" else "/Logo_orion_blanc.png"

    Column(
        modifier = Modifier
            .width(240.px)
            .minHeight(100.vh)
            .backgroundColor(colors.sidebarBg)
            .styleModifier {
                property("flex-shrink", "0")
            },
        verticalArrangement = Arrangement.SpaceBetween,
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(leftRight = 20.px, topBottom = 20.px),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Image(
                    src = logoPath,
                    alt = "Orion",
                    modifier = LogoStyle.toModifier()
                        .cursor(Cursor.Pointer)
                        .onClick { ctx.router.navigateTo("/") }
                )
            }
            //NavItems
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(leftRight = 12.px)
                    .gap(2.px)
            ) {
                SidebarNavItem(
                    icon = { FaHouse(modifier = Modifier.fontSize(14.px)) },
                    label = strings.sidebarHome,
                    isActive = currentSection == ProfileSection.HOME,
                    colors = colors,
                    onClick = { onSectionChange(ProfileSection.HOME) }
                )
                SidebarNavItem(
                    icon = { FaUser(modifier = Modifier.fontSize(14.px)) },
                    label = strings.sidebarPersonalInfo,
                    isActive = currentSection == ProfileSection.PERSONAL_INFO,
                    colors = colors,
                    onClick = { onSectionChange(ProfileSection.PERSONAL_INFO) }
                )
                SidebarNavItem(
                    icon = { FaShield(modifier = Modifier.fontSize(14.px)) },
                    label = strings.sidebarSecurity,
                    isActive = currentSection == ProfileSection.SECURITY,
                    colors = colors,
                    onClick = { onSectionChange(ProfileSection.SECURITY) }
                )
            }
        }

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(leftRight = 12.px, bottom = 16.px)
                .gap(8.px)
        ) {
            // Card "Besoin d'aide ?"
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(14.px)
                    .borderRadius(12.px)
                    .backgroundColor(colors.inputBg)
                    .gap(3.px)
            ) {
                SpanText(
                    strings.sidebarHelp,
                    modifier = Modifier
                        .fontSize(AuthTypography.small)
                        .fontWeight(FontWeight.SemiBold)
                        .color(colors.onBackground)
                )
                SpanText(
                    strings.sidebarHelpSubtitle,
                    modifier = Modifier
                        .fontSize(AuthTypography.tiny)
                        .color(colors.mutedText)
                )

                Box(modifier = Modifier.height(10.px))

                // Bouton "Centre d'aide"
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(leftRight = 10.px, topBottom = 8.px)
                        .borderRadius(8.px)
                        .backgroundColor(colors.sidebarBg)
                        .border(1.px, LineStyle.Solid, colors.border)
                        .cursor(Cursor.Pointer)
                        .gap(8.px)
                        .onClick { isHelpOpen = !isHelpOpen },
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.gap(8.px)
                    ) {
                        FaHeadset(modifier = Modifier.fontSize(13.px).color(colors.mutedText))
                        SpanText(
                            strings.sidebarHelpCenter,
                            modifier = Modifier
                                .fontSize(AuthTypography.small)
                                .fontWeight(FontWeight.Medium)
                                .color(colors.onBackground)
                        )
                    }
                    if (isHelpOpen) {
                        FaChevronUp(modifier = Modifier.fontSize(10.px).color(colors.mutedText))
                    } else {
                        FaChevronDown(modifier = Modifier.fontSize(10.px).color(colors.mutedText))
                    }
                }

                // Contenu dépliable
//                if (isHelpOpen) {
//                    Column(modifier = Modifier.padding(top = 8.px).gap(6.px)) {
//                        SpanText(
//                            "FAQ",
//                            modifier = Modifier
//                                .fontSize(AuthTypography.tiny)
//                                .cursor(Cursor.Pointer)
//                                .color(colors.primary)
//                        )
//                        SpanText(
//                            "Contact Support",
//                            modifier = Modifier
//                                .fontSize(AuthTypography.tiny)
//                                .cursor(Cursor.Pointer)
//                                .color(colors.primary)
//                        )
//                    }
//                }

                // Contenu dépliable
                if (isHelpOpen) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(top = 8.px, leftRight = 4.px)
                            .gap(8.px)
                    ) {
                        // Option 1 : Lien FAQ / Documentation
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .cursor(Cursor.Pointer)
                                .gap(6.px)
                                .onClick {
                                    // Redirection vers une page dédiée ou ouverture d'un onglet
                                    ctx.router.navigateTo("/faq") // ou window.open("https://docs.votre-domaine.com/faq")
                                },
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            FaCircleQuestion(modifier = Modifier.fontSize(11.px).color(colors.primary))
                            SpanText(
                                "Foire aux questions (FAQ)",
                                modifier = Modifier
                                    .fontSize(AuthTypography.tiny)
                                    .fontWeight(FontWeight.Medium)
                                    .color(colors.primary)
                            )
                        }

                        // Option 2 : Contact Support Direct via Email
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .cursor(Cursor.Pointer)
                                .gap(6.px)
                                .onClick {
                                    // Option A : Si le support est une page interne à ton projet Kobweb
                                    //ctx.router.navigateTo("/support")

                                    // Option B : Si le support est un site web externe (ex: Freshdesk, Zendesk, HelpScout)
                                     window.open("https://horion.io", "_blank")
                                },
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            FaEnvelope(modifier = Modifier.fontSize(11.px).color(colors.primary))
                            SpanText(
                                "Contacter le support client",
                                modifier = Modifier
                                    .fontSize(AuthTypography.tiny)
                                    .fontWeight(FontWeight.Medium)
                                    .color(colors.primary)
                            )
                        }
                    }
                }
            }

            // Bouton "Se déconnecter"
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(leftRight = 16.px, topBottom = 12.px)
                    .borderRadius(10.px)
                    .backgroundColor(colors.sidebarBg)
                    .border(1.px, LineStyle.Solid, colors.border)
                    .cursor(Cursor.Pointer)
                    .gap(10.px)
                    .onClick { onLogout() },
                verticalAlignment = Alignment.CenterVertically,
            ) {
                FaArrowRightFromBracket(modifier = Modifier.fontSize(14.px).color(colors.error))
                SpanText(
                    strings.logout,
                    modifier = Modifier
                        .fontSize(AuthTypography.small)
                        .fontWeight(FontWeight.Medium)
                        .color(colors.error)
                )
            }
        }
    }
}

//NavItems

@Composable
private fun SidebarNavItem(
    icon: @Composable () -> Unit,
    label: String,
    isActive: Boolean,
    colors: io.horion.auth.presentation.ui.theme.AuthColors,
    onClick: () -> Unit,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(leftRight = 12.px, topBottom = 10.px)
            .borderRadius(10.px)
            .backgroundColor(if (isActive) colors.sidebarActiveItem else Colors.Transparent)
            .cursor(Cursor.Pointer)
            .gap(12.px)
            .styleModifier { property("transition", "background 0.15s") }
            .onClick { onClick() },
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Box(
            modifier = Modifier
                .width(18.px)
                .color(if (isActive) colors.sidebarActivePrimary else colors.mutedText),
            contentAlignment = Alignment.Center
        ) {
            icon()
        }
        SpanText(
            label,
            modifier = Modifier
                .fontSize(AuthTypography.small)
                .fontWeight(if (isActive) FontWeight.SemiBold else FontWeight.Normal)
                .color(if (isActive) colors.sidebarActivePrimary else colors.onBackground)
        )
    }
}
